import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from "ngx-spinner";
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { MainService } from './main.service';
// import { UstpSettingService } from './ustp-setting.service';
import { TokenService } from '../../token.service';
import { session } from '../../../environments/environment.session';
import { MainService as MainServicep } from '../../portal/service/main.service'

@Injectable({
  providedIn: 'root'
})
export class DataControlService {

  erpUser:any;
  b_acct_id:any
  userId:any

  assigned_centers_ids :any= [0]
  assigned_zone_code :any= [0]
  constructor(private http: HttpClient, private spinner: NgxSpinnerService, private main: MainService, 
    private token:TokenService,private mainServicep:MainServicep) { }

  async gettingLogInfo() {
this.erpUser=JSON.parse(atob(session.erpUser));    this.b_acct_id = this.erpUser.b_acct_id;
    this.userId = this.erpUser.user_id;
  }
  async getAssignedCenters() {
    await this.gettingLogInfo();
    this.spinner.show();
    let obj :any= new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['user_id'] = this.userId;
    const resp = await this.getAllAssignedCenters(JSON.stringify(obj));
    // console.log(' Obj is : ', obj , "and dsvsd is : ",resp);
    this.assigned_centers_ids = []
    if (resp['center_id'].length > 0) {
      this.assigned_centers_ids = resp['center_id'];
    } else {
      this.assigned_centers_ids.push(0);
    }
    this.assigned_zone_code = resp['zone_code'];
    this.spinner.hide();

  }


  async getAllAssignedComponent(b_acct_id: any, role_cd: any, module_cd: any) {
    let obj: any ={};
    obj['b_acct_id'] = b_acct_id;
    obj['role_cd'] = role_cd;
    obj['module_cd'] = [module_cd];
    console.log(obj);

    var resp = await this.mainServicep.getAllAssignedComponents(JSON.stringify(obj));
    if (resp['error'] == false) {
      
      this.erpUser=JSON.parse(atob(session.erpUser)) ;
      this.erpUser.assigned_component = []

      for (let i = 0; i < resp['data'].length; i++) {
        if (!this.erpUser.assigned_component.includes(resp['data'][i]['resource_cd']))
          this.erpUser.assigned_component.push(resp['data'][i]['resource_cd'])
      }
      session.erpUser = btoa(JSON.stringify(this.erpUser))
       
    } else {
    }
  
  }



  async getAllAssignedCenters(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/training-center/trainee_data_assignment/getAssignedCenters' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }



}
